// Backend error bodies show up as either an array of strings or a keyed object
// (e.g. `{ email: 'is invalid' }` from validation endpoints). Callers throughout
// the app assume `errors` is always a string array, so normalize both shapes here
// rather than at each call site.
export const normalizeApiErrors = (errors: unknown): string[] => {
  if (Array.isArray(errors)) {
    return errors;
  }
  if (errors && typeof errors === 'object') {
    return Object.values(errors).map(String);
  }

  return [];
};
